import { useCallback } from 'react'
import {
  Route,
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
} from 'react-router-dom'
import TabsComponent from 'src/components/Tabs'
import BarcodesTab from '../Tabs/BarcodesTab'
import MovementsTab from '../Tabs/MovementTab'
import ReservesTab from '../Tabs/ReservesTab'
import MovementsByTypeTab from '../Tabs/MovementsByTypeTab'
import {
  barcodeTab, movementTab, reservesTab, tabs, movementsByTypeTab,
} from './ProductTabs.data'
import * as S from './ProductTabs.styles'

export default () => {
  const { path, url } = useRouteMatch()
  const { pathname } = useLocation()
  const history = useHistory()

  const setTab = useCallback(
    (pathName: string) => {
      history.push(`${url}/${pathName}`)
    },
    [url, history],
  )

  const createTab = ({
    title,
    endpoint,
  }: {
    title: string
    endpoint: string
  }) => ({
    title,
    action: () => setTab(endpoint),
  })

  const getActiveTab = useCallback(() => {
    const endpoint = pathname?.split('/')?.slice(-1).pop()
    const currentTab = tabs.find((t) => t.endpoint === endpoint)
    return currentTab?.title ? currentTab.title : movementTab.title
  }, [pathname])

  return (
    <>
      <TabsComponent
        tabs={[
          createTab(movementTab),
          createTab(barcodeTab),
          createTab(reservesTab),
          createTab(movementsByTypeTab),
        ]}
        activeTab={getActiveTab()}
      />
      <S.TabWrapper>
        <Switch>
          <Route exact path={[path, `${path}/movements`]}>
            <MovementsTab />
          </Route>
          <Route path={`${path}/barcodes`}>
            <BarcodesTab />
          </Route>
          <Route path={`${path}/reserves`}>
            <ReservesTab />
          </Route>
          <Route path={`${path}/movements-by-type`}>
            <MovementsByTypeTab/>
          </Route>
        </Switch>
      </S.TabWrapper>
    </>
  )
}
